import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { fetchResource, getIntlMessage, loadEntities, showErrorMessage, updateEntity } from 'helpers/utilHelpers';
import {
  FILL_USER,
  FILL_USER_CLIENT,
  INVITE_USER,
  INVITE_USER_CLIENT,
  LOAD_CLIENT_WIZARD_USER,
  LOAD_WIZARD_USER,
  SIGN_UP_CONFIRM,
} from 'constants/ActionTypes';
import { hideLoader } from 'actions/settingActions';
import { setCookie } from 'helpers/cookieHelpers';
import { AUTH_COOKIE } from 'constants/UtilConstants';

function* fetchProfileFilling(action) {
  const { promise, values, payload, queryParams } = action;
  const { resolve, reject } = promise;
  const { resource, onSuccess, afterSuccess } = payload;

  try {
    const response = yield call(() => fetchResource(resource, 'POST', values, null, queryParams));

    setCookie(AUTH_COOKIE, response.token, 10 * 365 * 24 * 60 * 60);

    if (onSuccess) {
      yield put(onSuccess(response, action));
    }

    if (afterSuccess) {
      yield put(afterSuccess(response, action));
    }

    if (resolve) {
      resolve();
    }

    yield put(hideLoader());
  } catch (response) {
    yield put(hideLoader());
    const data = yield response.json();

    if (response.status && response.status === 422) {
      reject(data);
      return;
    }
    yield showErrorMessage(getIntlMessage('request.error'));
  }
}

function* inviteUserProfile() {
  yield takeEvery(INVITE_USER, updateEntity);
}

function* loadWizardUserProfile() {
  yield takeEvery(LOAD_WIZARD_USER, loadEntities);
}

function* fillUserProfile() {
  yield takeEvery(FILL_USER, fetchProfileFilling);
}

function* inviteUserClientProfile() {
  yield takeEvery(INVITE_USER_CLIENT, updateEntity);
}

function* loadClientWizardUser() {
  yield takeEvery(LOAD_CLIENT_WIZARD_USER, loadEntities);
}

function* fillUserClientProfile() {
  yield takeEvery(FILL_USER_CLIENT, fetchProfileFilling);
}

function* signUpConfirm() {
  yield takeEvery(SIGN_UP_CONFIRM, updateEntity);
}

export default function* rootSaga() {
  yield all([
    // User profile
    fork(inviteUserProfile),
    fork(loadWizardUserProfile),
    fork(fillUserProfile),
    fork(signUpConfirm),

    // User client profile
    fork(inviteUserClientProfile),
    fork(loadClientWizardUser),
    fork(fillUserClientProfile),
  ]);
}
